<template>
  <div class="inclusion-exclusion">
    <div class="info-panel">
      <div class="info-title">
        纳入条件
      </div>
      <template v-if="datasource1.length === 0">
        <a-empty :image="simpleImage" class="empty" />
      </template>
      <ul class="list1">
        <li v-for="(item, index) in datasource1" :key="index">
          <div class="left">
            <span class="num">{{ item.sortNum }}</span>
            <span class="content">{{ item.description }}</span>      
            <span class="center" v-if="item.centerName">{{ item.centerName }}</span>      
          </div>
          <div class="right">
            <a href="javascript:;" class="operate" @click="handleEdit(item)">编辑</a>
            <a-divider type="vertical" class="line" />
            <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(item.id)">
              <a href="javascript:;" class="operate">删除</a>
            </a-popconfirm>
          </div>
        </li>
        <li @click="handleAdd(datasource1.length,'1')">
          <a-icon type="plus" />
          <span>新增条件</span>
        </li>
      </ul>
    </div>

    <div class="info-panel">
      <div class="info-title">
        排除条件
      </div>
      <template v-if="datasource2.length === 0">
        <a-empty :image="simpleImage" class="empty" />
      </template>
      <ul class="list1">
        <li v-for="(item, index) in datasource2" :key="index">
          <div class="left">
            <span class="num">{{ item.sortNum }}</span>
            <span class="content">{{ item.description }}</span>   
            <span class="center" v-if="item.centerName">{{ item.centerName }}</span>         
          </div>
          <div class="right">
            <a href="javascript:;" class="operate" @click="handleEdit(item)">编辑</a>
            <a-divider type="vertical" class="line" />
            <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(item.id)">
              <a href="javascript:;" class="operate">删除</a>
            </a-popconfirm>
          </div>
        </li>
        <li @click="handleAdd(datasource2.length,'2')">
          <a-icon type="plus" />
          <span>新增条件</span>
        </li>
      </ul>
    </div>

    <a-modal v-if="isEdit" class="ant-modal-custom" rowKey="id" :width="600" :visible="formVisible"
      :confirmLoading="confirmLoading" @cancel="handleCancel">
      <div class="modal-title">
        编辑
      </div>
      <a-form-model :model="model" layout="horizontal" :rules="rules">
        <div class="item">
          <a-form-model-item label="分组名称" props="type">
            <a-radio-group v-model="model.type">
              <a-radio value="1" style="color: white;">纳入条件</a-radio>
              <a-radio value="2" style="color: white;">排除条件</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </div>
        <div class="item">
          <a-form-model-item label="内容" props="description">
            <a-textarea :rows="2" v-model="model.description" />
          </a-form-model-item>
        </div>
        <div class="item">
          <a-form-model-item label="排序" props="sortNum">
            <a-input-number v-model="model.sortNum" :min="0" :precision="0" data-id="ddd" />
          </a-form-model-item>
        </div>
        <div class="item">
          <a-form-model-item label="备注弹框" props="sortNum">
            <a-switch checkedChildren="开启" unCheckedChildren="关闭" v-model="remarkFlag" @change="onSwitchChange" />
          </a-form-model-item>
        </div>
        <div class="item">
          <a-form-model-item label="所属中心">
          <a-select placeholder="请选择研究中心" v-model="model.centerId" style="width: 200px" allow-clear>
              <a-select-option v-for="(item,index) in centerList" :key="index" :value="item.centerId">
                {{ item.center.name }}
              </a-select-option>
            </a-select>
        </a-form-model-item>
        </div>
      </a-form-model>
      <template slot="footer">
        <gradient-btn @click="handleSubmit">确定</gradient-btn>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { getAction, postAction, deleteAction } from '@/api/manage'
import baseRules from '@/constants/baseRules'
import IconBack from '@comp/Icon/IconBack.vue';
import { Empty } from 'ant-design-vue';
import GradientBtn from '@comp/pad/GradientBtn'
export default {
  name: 'FiltratePad',
  components: { IconBack , GradientBtn},
  props: {
    projectId: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    url: {
      type: Object,
      default: () => {
        return {
          listUrl: '/project/projectFiltrate/list',
          deleteUrl: '/project/projectFiltrate/delete',
          saveUrl: '/project/projectFiltrate/saveOrUpdate',
        }
      }
    },
  },
  data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      datasource: [],
      formVisible: false,
      confirmLoading: false,
      edit: false,
      loading: false,
      remarkFlag:false,
      model: {},
      rules: {
        type: [baseRules.required],
        description: [baseRules.required],
        sortNum: [baseRules.required],
      },
      columns: [
        {
          title: '排序',
          align: 'center',
          width: 100,
          dataIndex: 'sortNum'
        },
        {
          title: '内容',
          align: 'left',
          ellipsis: true,
          dataIndex: 'description'
        },
        {
          title: '所属中心',
          align: 'center',
          width: 150,
          dataIndex: 'centerName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'action' },
        }
      ],
      centerList: [],
    }
  },
  watch: {
    projectId() {
      this.loadData()
    }
  },
  computed: {
    datasource1() {
      return this.datasource.filter(item => item.type === '1')
    },
    datasource2() {
      return this.datasource.filter(item => item.type === '2')
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.projectId) {
        return
      }
      const projectId = this.projectId
      this.loading = true
      var that = this
      getAction(this.url.listUrl, { projectId: projectId }).then(res => {
        if (res.success) {
          that.datasource = res.result
          if(that.datasource.length===0){
            let filter=[];
            filter.push({"projectId":projectId,"type":"1","sortNum":1,"remarkFlag":'0',"description":"年龄40-65岁，性别不限；"})            
            filter.push({"projectId":projectId,"type":"1","sortNum":2,"remarkFlag":'0',"description":"择期行非心脏、非日间手术；"})            
            filter.push({"projectId":projectId,"type":"1","sortNum":3,"remarkFlag":'0',"description":"全身麻醉；"})            
            filter.push({"projectId":projectId,"type":"2","sortNum":1,"remarkFlag":'0',"description":"小学以下文化程度；"})            
            filter.push({"projectId":projectId,"type":"2","sortNum":2,"description":"不能理解访谈及量表内容；"})
            
            postAction('/project/projectFiltrate/saveBatch', filter).then(saveRes =>{
              console.log("saveRes:"+ saveRes)
              if(saveRes.success){
                // that.datasource = res.result
                that.loadData()
              }
            })            
          }
        }
      }).finally(() => {
        that.loading = false
      })
      that.loadCenter()
    },
    handleAdd(num,type) {
      this.handleEdit({ projectId: this.projectId, type, sortNum: num + 1,remarkFlag:'0' })
    },
    handleEdit(record) {
      if (!this.projectId) {
        return this.$message.error('非法参数')
      }
      this.model = Object.assign({}, record)
      this.remarkFlag= this.model.remarkFlag==='1'?true:false
      this.formVisible = true
    },
    handleDelete(id) {
      deleteAction(this.url.deleteUrl, { id: id }).then(res => {
        if (res.success) {
          this.loadData()
        }
      })
    },
    handleCancel() {
      this.model = {}
      this.formVisible = false
    },
    handleSubmit() {
      this.confirmLoading = true
      postAction(this.url.saveUrl, this.model).then(res => {
        if (res.success) {
          this.loadData()
          this.handleCancel()
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    onSwitchChange(){
       this.model.remarkFlag = this.remarkFlag ? '1' : '0'
    },
    loadCenter(){
      getAction('/project/center/listAll', { projectId: this.projectId }).then(res => {
        if (res.success) {
          this.centerList = res.result
        }
      })
    }
  }

}
</script>

<style scoped lang="less">
.inclusion-exclusion {
  .info-panel {
    margin-bottom: 10px;

    .info-title {
      font-size: 16px;
      color: white;
      padding: 15px 0 5px;
    }

    .info-item {
      margin-left: 20px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      line-height: 28px;
    }
  }

  .list1 {
    list-style: none;
    margin: 0;
    padding: 0;
    overflow: hidden;

    li {
      overflow: hidden;
      color: white;
      padding: 12px 10px;
      height: 46px;
      // display: grid;
      // align-items: center;
      // grid-template-columns: 22px 1fr auto auto auto;
      display: flex;
      justify-content: space-between;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 8px 8px 8px 8px;
      margin-top: 10px;
      border: 1px dashed transparent;

      .num {
        display: inline-block;
        width: 22px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        border-radius: 6px;
        background-color: #376EFF;
        font-weight: 400;
        font-size: 14px;
      }

      .content {
        margin-left: 10px;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      }
      .center {
        margin-left: 10px;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      }

      /deep/ .line {
        height: 18px;
        // margin-top: 2px;
      }

      .operate {
        font-size: 12px;
        color: white;
        padding: 0 5px;
      }
    }

    li:last-child {
      cursor: pointer;
      padding: 12px 0;
      justify-content: center;
      align-items: center;
      border: 1px dashed rgba(255, 255, 255, 0.15);

      span {
        margin-left: 10px;
      }
    }
  }
}

.empty {
  /deep/ .ant-empty-description {
    color: white;
  }
}

.ant-modal-custom {
  .modal-title {
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 21px;
  }

  .item {
    margin-top: 10px;
    padding: 5px 15px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 12px 12px 12px 12px;
  }

  /deep/ .ant-modal-content {
    //191f35  252628
    background: linear-gradient(to bottom, #191f35, #252628);
  }

  /deep/ .ant-form-item-label>label {
    font-weight: 400;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 16px;
  }

  /deep/ .ant-form-item {
    margin-bottom: 0;
  }

  /deep/ .ant-upload.ant-upload-select-picture-card {
    background: transparent;
  }

  /deep/ .has-error .ant-input,
  .has-error .ant-input:hover {
    background: transparent;
  }

  /deep/ .ant-input {
    background: transparent;
    color: rgba(255, 255, 255, 0.4);
  }

  /deep/ .ant-select-selection {
    background: transparent;
    color: rgba(255, 255, 255, 0.4);
  }

  /deep/ .ant-modal-footer {
    text-align: center;
    border-top: 0;
    padding-bottom: 30px;

    // button {
    //   width: 240px;
    //   height: 40px;
    //   background: #5F5F5F;
    //   border-radius: 29px 29px 29px 29px;
    //   border: 0;
    //   font-weight: 400;
    //   font-size: 14px;
    //   color: rgba(255, 255, 255, 0.4);
    // }
  }

  /deep/ .ant-modal-close {
    color: white;
  }

  /deep/ .ant-input-number {
    width: 100%;
    background: transparent;
  }

  /deep/ .ant-input-number-input,
  /deep/ .ant-input-number-input-wrap {
    background: transparent;
    color: white;
  }
}
</style>